export enum MissionTab {
  Schedules = 'Schedules',
  Uploaded = 'Uploaded',
  AllProjects = 'All Projects',
}
